import axios from "@/api/config";

const goodsInfoCenter = {
  getGoodsInfoById(data) {
    return axios.get(
      `${process.env.BASE_URL}/goodsInfoCenter/getGoodsInfo/` + data,
      {}
    );
  },
  getGoodsInfo(data) {
    return axios.get(
      `${process.env.BASE_URL}/goodsInfoCenter/getGoodsInfoCenter`,
      {
        params: data
      }
    );
  },
  getGoodsInfoList(data) {
    return axios.get(
      `${process.env.BASE_URL}/goodsInfoCenter/getGoodsInfoList`,
      {
        params: data
      }
    );
  },
  getGoodsInfoTree(data) {
    return axios.get(
      `${process.env.BASE_URL}/goodsInfoCenter/getGoodsInfoTree`,
      {
        params: data
      }
    );
  },
  getGoodsInfoStats(data) {
    return axios.get(
      `${process.env.BASE_URL}/goodsInfoCenter/getGoodsInfoStats`,
      {
        params: data
      }
    );
  },
  getGoodsTypeList(data) {
    return axios.get(`${process.env.BASE_URL}/goodsInfo/getGoodsTypeList`, {
      params: data
    });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/goodsInfoCenter/pageList`, data);
  },
  goodsBatchOn(data) {
    return axios.post(
      `${process.env.BASE_URL}/goodsInfoCenter/goodsBatchOn`,
      data
    );
  },
  goodsBatchOff(data) {
    return axios.post(
      `${process.env.BASE_URL}/goodsInfoCenter/goodsBatchOff`,
      data
    );
  },
  addGoodsInfo(data) {
    return axios.post(
      `${process.env.BASE_URL}/goodsInfoCenter/addGoodsInfoCenter`,
      data
    );
  },
  updateGoodsInfo(data) {
    return axios.put(
      `${process.env.BASE_URL}/goodsInfoCenter/updateGoodsInfoCenter`,
      data
    );
  },
  deleteGoodsInfo(data) {
    return axios.delete(
      `${process.env.BASE_URL}/goodsInfoCenter/deleteGoodsInfo`,
      {
        data: data
      }
    );
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/goodsInfoCenter/exportExcel`, {
      params: data
    });
  },
  getStudentBuyGoodsList(data) {
    return axios.get(
      `${process.env.BASE_URL}/goodsInfoCenter/getStudentBuyGoodsList`,
      {
        params: data
      }
    );
  },
  importData(data) {
    return axios.post(
      `${process.env.BASE_URL}/goodsInfoCenter/importData`,
      data
    );
  },
  goodsMarketPageList(data) {
    return axios.post(
      `${process.env.BASE_URL}/goodsInfoCenter/goodsMarketPageList`,
      data
    );
  },
  batchAddGoodsInfo(data) {
    return axios.post(
      `${process.env.BASE_URL}/goodsInfoCenter/batchAddGoodsInfo`,
      data
    );
  },
  pageListHasAgentPrice(data) {
    return axios.post(
      `${process.env.BASE_URL}/goodsInfoCenter/pageListHasAgentPrice`,
      data
    );
  },
  pageListCampus(data) {
    return axios.post(`${process.env.BASE_URL}/campus/pageList`, data);
  },
  pageListInformation(data) {
    return axios.post(
      `${process.env.BASE_URL}/schoolPage/informationPageList`,
      data
    );
  },
  pageListPolicy(data) {
    return axios.post(`${process.env.BASE_URL}/policy/pageList`, data);
  },
  getGoodsCommentList(data) {
    return axios.get(
      `${process.env.BASE_URL}/goodsComment/getGoodsCommentList`,
      {
        params: data
      }
    );
  },
  getBiGuoProductList(data) {
    return axios.post(
      `${process.env.BASE_URL}/biGuoSources/getBiGuoProductList`,
      data
    );
  }
};

export default goodsInfoCenter;



// WEBPACK FOOTER //
// ./src/api/goodsInfo.js